import *  as axios from 'axios';
import * as ActionTypesService from '../../constants/actiontypes/services';
import * as ActionTypesConfig from '../../constants/actiontypes/backoffice/configuration';
import * as urls from '../../constants/webapi/services';
import * as urlsConfig from '../../constants/webapi/backoffice/configuration';
import { convertConnectionTypesToServiceType } from '../../constants/utils/connectionTypes';

export function resetServices() {
    return {
        type: ActionTypesService.RESET_SERVICES,
    };
}
export function fetchServices(serviceType, pageNumber, searchTerm, sortByTerm, sortDesc, lifeEvent) {
	let frenchServiceType = convertConnectionTypesToServiceType(serviceType);
	pageNumber -= 1;

	return (dispatch) => {
		dispatch({ type: ActionTypesService.FETCH_SERVICES_REQUEST, serviceType: serviceType });
		return axios
			.get(urls.serviceByServiceTypeSearchUrl(frenchServiceType, pageNumber, searchTerm, sortByTerm, sortDesc, lifeEvent))
			.then((response) => {
				dispatch({
					type: ActionTypesService.FETCH_SERVICES_SUCCESS,
					data: response.data,
					serviceType: serviceType,
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response.status === 404) {
					dispatch({
						type: ActionTypesService.FETCH_SERVICES_FAILURE,
						serviceType: serviceType,
					});
					return;
				}
				dispatch({
					type: ActionTypesService.FETCH_SERVICES_FAILURE,
					response: error.response,
				});
				throw error.statusText;
			});
	};
}

export function createService(service, serviceType) {

    //let frenchServiceType = convertConnectionTypesToServiceType(serviceType);

    return (dispatch) => {
        dispatch({ type: ActionTypesService.CREATE_SERVICES_REQUEST });
        return axios.post(urls.serviceUrl(), service)
            .then((response) => {
                dispatch({
                    type: ActionTypesService.CREATE_SERVICES_SUCCESS,
                    data: response.data,
                    serviceType: serviceType
                });
                return response.data;
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    dispatch({
                        type: ActionTypesService.CREATE_SERVICES_FAILURE,

                    });
                    return;
                }
                dispatch({
                    type: ActionTypesService.CREATE_SERVICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function updateService(id, serviceType, service) {

    //let frenchServiceType = convertConnectionTypesToServiceType(serviceType);

    return (dispatch) => {
        dispatch({ type: ActionTypesService.UPDATE_SERVICES_REQUEST });
        return axios.put(urls.serviceByIdUrl(id), service)
            .then((response) => {
                dispatch({
                    type: ActionTypesService.UPDATE_SERVICES_SUCCESS,
                    data: response.data,
                    serviceType: serviceType
                });
                return response.data;
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    dispatch({
                        type: ActionTypesService.UPDATE_SERVICES_FAILURE,

                    });
                    return;
                }
                dispatch({
                    type: ActionTypesService.UPDATE_SERVICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function deleteService(service) {
    return (dispatch) => {
        dispatch({ type: ActionTypesService.DELETE_SERVICE_BY_ID_REQUEST });
        return axios.delete(urls.serviceByIdUrl(service.id))
            .then((response) => {
                dispatch({
                    type: ActionTypesService.DELETE_SERVICE_BY_ID_SUCCESS,
                    data: response.data,
                    service: service
                });
                return response.data;
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    dispatch({
                        type: ActionTypesService.DELETE_SERVICE_BY_ID_FAILURE,
                        service: service

                    });
                    return;
                }
                dispatch({
                    type: ActionTypesService.DELETE_SERVICE_BY_ID_FAILURE,
                    response: error.response,
                    service: service
                });
                throw error.statusText;
            });
    };
}


export function createPostalNumber(postalNumber) {

    return (dispatch) => {
        dispatch({ type: ActionTypesConfig.CREATE_POSTAL_NUMBER_REQUEST });
        return axios.post(urlsConfig.postalNumberUrl(), postalNumber)
            .then((response) => {
                dispatch({
                    type: ActionTypesConfig.CREATE_POSTAL_NUMBER_SUCCESS,
                    data: response.data,

                });
                return response.data;
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    dispatch({
                        type: ActionTypesConfig.CREATE_POSTAL_NUMBER_FAILURE,
                    });
                    return;
                }
                dispatch({
                    type: ActionTypesConfig.CREATE_POSTAL_NUMBER_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function getProductsPrices() {

    return (dispatch) => {
        dispatch({ type: ActionTypesConfig.FETCH_PRICE_REQUEST });
        return axios.get(urlsConfig.productsPricesUrl())
            .then((response) => {
                dispatch({
                    type: ActionTypesConfig.FETCH_PRICE_SUCCESS,
                    data: response.data,

                });
                return response.data;
            })
            .catch((error) => {

                dispatch({
                    type: ActionTypesConfig.FETCH_PRICE_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


// export function updateProductPrice(product) {

//     return (dispatch) => {
//         dispatch({ type: ActionTypesConfig.UPDATE_PRICE_REQUEST });
//         return axios.patch(urlsConfig.productUrl(product.product), product)
//             .then((response) => {
//                 dispatch({
//                     type: ActionTypesConfig.UPDATE_PRICE_SUCCESS,
//                     data: product,

//                 });
//                 return response.data;
//             })
//             .catch((error) => {
//                 if (error.response.status === 404) {
//                     dispatch({
//                         type: ActionTypesConfig.UPDATE_PRICE_FAILURE,
//                     });
//                     return;
//                 }
//                 dispatch({
//                     type: ActionTypesConfig.UPDATE_PRICE_FAILURE,
//                     response: error.response
//                 });
//                 throw error.statusText;
//             });
//     };
// }

export function updateProductPrice(product) {

    return new Promise((resolve, reject) => {
        axios.patch(urlsConfig.productUrl(product.product), product)
            .then((response) => {

                resolve(response.data);
            })
            .catch((error) => {

                reject(error);
            });
    });
};
